import React from 'react';
import { motion } from 'framer-motion';
import { trackAddToCart } from '../utils/pixel';
export function CTAButton({
  children,
  className = '',
  onClick,
  href
}: {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
  href?: string;
}) {
  const handleClick = () => {
    if (onClick) onClick();else if (href) {
      trackAddToCart();
      window.open(href, '_blank');
    } else {
      document.getElementById('offer')?.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <motion.button whileHover={{
    scale: 1.05
  }} whileTap={{
    scale: 0.95
  }} onClick={handleClick} className={`bg-orange text-white font-bold text-lg md:text-xl py-4 px-8 rounded-full shadow-lg hover:bg-[#e06b18] transition-colors w-full sm:w-auto flex items-center justify-center text-center ${className}`} data-id="element-1">
      {children}
    </motion.button>;
}
export function FadeIn({
  children,
  delay = 0,
  className = ''
}: {
  children: React.ReactNode;
  delay?: number;
  className?: string;
}) {
  return <motion.div initial={{
    opacity: 0,
    y: 30
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-100px'
  }} transition={{
    duration: 0.7,
    delay,
    ease: 'easeOut'
  }} className={className} data-id="element-2">
      {children}
    </motion.div>;
}